import { JSONTag, Tag } from 'models/tag';
import TagsManagerBase from './base';

export default class TopicPeopleTagsManager extends TagsManagerBase {
    topicId: string

    constructor(topicId: string) {
        super();

        this.topicId = topicId;
    }

    addTag(jsonTag: JSONTag): Promise<void> {
        throw new Error('Unsupported operation');
    }

    removeTag(tag: Tag): Promise<void> {
        throw new Error('Unsupported operation');
    }

    protected async load() {
        return await this.ctx.tagsService.queries.topicPeopleTags(this.topicId).background().toArray();
    }
}